import type { RootStateOrAny } from 'react-redux'
import { useSelector } from 'react-redux'

import { useCollection } from 'hooks/menu-collections'

import { CollectionId } from '../../domains/collections'

export const useShowJFYTutorial = () => {
  const jfyTutorialSeen = useSelector(({ tutorial }: RootStateOrAny) =>
    Boolean(tutorial && tutorial.getIn(['viewed', 'justforyou'])),
  )
  const recommendationsCollection = useCollection(CollectionId.Recommendations)

  if (jfyTutorialSeen) {
    return false
  }

  if (!recommendationsCollection) {
    return false
  }

  // previously we used to check if recommendations collection properties had tutorial = jfy
  // in menu v3 this data doesn't exist, but looking at the backend code, it seems that jfy was hardcoded
  return true
}
